import {useQuery} from '@tanstack/react-query';
import {GetCategoriesWithTagsResponse} from '../../generated/models/GetCategoriesWithTagsResponse';
import {
  categoriesCache,
  categoriesWithTagsCache,
} from '../constants/queryCacheKey';
import {apiRequest} from '../services/api';
import {categories, categoriesWithTagsEndpoint} from '../constants/endpoints';
import {CategoryCodeNameDto} from '../../generated/models/CategoryCodeNameDto';

export type CategoriesWithTagsDto = GetCategoriesWithTagsResponse;

export const useCategoriesWithTags = () => {
  return useQuery({
    queryKey: [categoriesWithTagsCache],
    queryFn: async (): Promise<CategoriesWithTagsDto[] | undefined> => {
      const response = await apiRequest<CategoriesWithTagsDto[]>(
        {
          method: 'GET',
          endpoint: categoriesWithTagsEndpoint,
        },
        {
          errorMessage: 'Failed to fetch categories with tags',
          defaultValue: undefined,
          shouldPrintLogs: false,
        },
      );
      return response?.data?.map(category => ({
        ...category,
        tags: [...(category.tags ?? [])].sort((a, b) =>
          (a.name ?? '').localeCompare(b.name ?? ''),
        ),
      }));
    },
    staleTime: 1000 * 60 * 60, // one hour
  });
};

export const useCategories = () => {
  return useQuery({
    queryKey: [categoriesCache],
    queryFn: async (): Promise<CategoryCodeNameDto[] | undefined> => {
      const response = await apiRequest<CategoryCodeNameDto[]>(
        {
          method: 'GET',
          endpoint: categories,
        },
        {
          errorMessage: 'Failed to fetch categories',
          defaultValue: undefined,
          shouldPrintLogs: false,
        },
      );
      return response?.data;
    },
    // staleTime: 1000 * 60 * 60, // oneHour
  });
};
